import { createContext, useContext, useEffect, useState } from "react";
import { content } from "./copy";

const LangContext = createContext({ lang: "en", t: content.en, toggle: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("mirai-lang") || "en");
  useEffect(() => {
    localStorage.setItem("mirai-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const toggle = () => setLang((l) => (l === "en" ? "hi" : "en"));
  return <LangContext.Provider value={{ lang, t: content[lang], toggle }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
